//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
let d=[[[0,"BaselineOfComparison",1,0],[1,"ChangeSymbolLineColorFontWidth",0,"LineColorFontWidthBuilder",0],[0,"ChangeSymbolSize",1,0],[0,"ChangeSymbolType",1,0],[0,"CompareMethod",1,0],[0,"CompareTolerance",1,0],[0,"CreateOverlayDataWithSnapshotData",1,0],[0,"DisplayChangeSymbol",1,0],[0,"IncrementIDNumberPerReport",1,0],[0,"PreserveChangeSymbolDisplay",1,0],[0,"RestartIDNumbersWithNewReport",1,0],[0,"SnapshotDataToUse",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.TrackDrawingChangesGeneralBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.TrackDrawingChangesGeneralBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.TrackDrawingChangesGeneralBuilder.CompareMethodType = Object.freeze({
    "AgainstAnotherDrawing" : "AgainstAnotherDrawing", "AgainstSnapshotDataInActiveDrawing" : "AgainstSnapshotDataInActiveDrawing", "OpenSavedComparisonReport" : "OpenSavedComparisonReport"});

SPLM.Drawings.TrackDrawingChangesGeneralBuilder.BaselineOfComparisonType = Object.freeze({
    "Snapshot" : "Snapshot", "TrackedChanges" : "TrackedChanges"});

SPLM.Drawings.TrackDrawingChangesGeneralBuilder.SnapshotDataToUseType = Object.freeze({
    "AskAtRunTime" : "AskAtRunTime", "AlwaysUseExistingData" : "AlwaysUseExistingData", "AlwaysCreateNewData" : "AlwaysCreateNewData", "CreateNewDataifNoneExists" : "CreateNewDataifNoneExists"});

SPLM.Drawings.TrackDrawingChangesGeneralBuilder.SymbolType = Object.freeze({
    "Circle" : "Circle", "TriangleUp" : "TriangleUp", "TriangleDown" : "TriangleDown", "Square" : "Square", "Hexagon" : "Hexagon"});

export default SPLM;